import type { PendingShare } from './shareIntent.js';

/** Polling and the native push can deliver the same cached file on resume. */
export function createShareNavigationHandler(navigate: (location: string) => void): (share: PendingShare) => void {
  let lastPath: string | null = null;
  return (share) => {
    if (lastPath === share.path) return;
    lastPath = share.path;
    const search = new URLSearchParams({
      fromShare: '1', sharePath: share.path, shareMime: share.mime,
      shareName: share.name, kind: 'ddt',
    });
    navigate(`/documents/capture?${search}`);
  };
}
